export const contact = {
  title: 'Contáctenos',
  subtitle: 'Estamos aquí para ayudarte. No dudes en contactarnos para cualquier pregunta.',
  form: {
    name: 'Nombre',
    email: 'Correo electrónico',
    subject: 'Asunto',
    message: 'Mensaje',
    submit: 'Enviar'
  }
}; 